export const SAVE_PROJECT = 'SAVE_PROJECT';
export const GET_PROJECTS = 'GET_PROJECTS';
export const CURRENT_PROJECT = 'CURRENT_PROJECT';
export const ADD_PROJECT = 'ADD_PROJECT';
